<template>
	<div class="page-mdl">
		<!-- 选项卡切换 -->
		<div class="m-tag-box">
			<span :class="{act:item.columnId==columnId}" @click="changeNewTag(item.columnId)"
				v-for="(item,index) in cateList" :key="item.columnId">{{item.columnName}}</span>
		</div>
		
		<div class="detail-page" v-if="detail">
			<h2 class="title">{{detail.contentTitle}}</h2>
			<div class="datetime">{{detail.createdDt.substring(0,10)}}  发表</div>
			<div class="detail-ctn" v-html="detail.contentDesc"></div>
		</div>
		<van-empty v-if="!detail" description="暂无内容" />
		
	</div>
</template>

<script>

export default {
	name: 'newsList',
	components:{
		
	},
	data () {
		return {
			firstCateId:'',	//一级栏目id
			cateList:[],	//二级栏目列表
			secondCateId:'',	//二级栏目id
			
			detail:null
		}
	},
	
	async created(){
		await this.$onLaunched;		//监听加载了APP.vue中的onLaunched的异步后执行
		this.firstCateId = this.$route.query.firstCateId
		this.getSecondColumnList()
	},
	
	watch:{
		$route(to,from){
			this.firstCateId = to.query.firstCateId
			this.getSecondColumnList()
		},
	},
  
	methods:{
		changeNewTag(columnId){
			this.goUrl({ name:'about', query:{firstCateId:this.firstCateId, secondCateId: columnId}})
		},
		
		//查询二级栏目
		getSecondColumnList(){
			let { firstCateId } = this
			//获取二级栏目列表
			this.$axios({
				url:`/jxedu/api/site/secondColumnList/${firstCateId}`,
			}).then(res=>{
				let list = res.data
				this.cateList = list
				const { secondCateId } = this.$route.query	
				this.columnId = secondCateId || list[0].columnId
				this.getNewList()
			})
		},
		
		//查询门户首页二级栏目数据
		getNewList(){
			const { columnId } = this
			this.$axios({
				url:`/jxedu/api/site/columnContents`,
				params:{
					columnId,
					pageNum:1,
					pageSize:1
				}
			}).then(res=>{
				let list = res.data.rows || []
				if(list.length>0){
					const { contentId } = list[0]
					this.getDetail(contentId)
				}
			})
		},
		
		//获取新闻详情
		getDetail(contentId){
			this.$axios({
				url:`/jxedu/api/site/findById/${contentId}`,
			}).then(res=>{
				let detail = res.data
				this.detail = detail
			})
		},
		
	}
}
</script>

<style lang="less">
@vm: 7.5vw;
body{ background:#F9F9F9; }

</style>



// WEBPACK FOOTER //
// src/pages/about/tpl-mobile.vue